const endpoints = {
  AUTH: {
    LOGIN: '/moderation/login/',
    MYINFO: '/moderation/users/me/',
    PASSWORD_RESET: '/auth/password/reset/',
    PASSWORD_RESET_CONFIRM: '/auth/password/reset/confirm/:uid/:token/',
  },
  PRODUCTS: {
    GET_MATCHING_ENGINE_PRODUCTS: '/moderation/pool/',
    GET_MATCHING_ENGINE_PRODUCT_VARIANTS: '/moderation/pool/:itemId/variants/',
    GET_MATCHING_ENGINE_PRODUCT_DATA: '/moderation/pool/:itemId/detailed/',
    SEARCH_BASE_PRODUCT: '/moderation/base-bottles/search/',
    VALIDATE_MATCH: '/moderation/pool/:itemId/validate-match/',
    MATCH: '/moderation/pool/:itemId/match/',
    CONVERT_TO_BASE_PRODUCT: '/moderation/pool/:itemId/convert-to-base-bottle/',
    GET_ENTITY_PRODUCTS: '/moderation/products/',
    GET_CATEGORIES: '/moderation/categories/detailed/',
    GET_RETAILER_PRODUCTS: '/moderation/products/search-retailers/',
    VALIDATE_MERGE: '/moderation/pool/validate-merge/',
    MERGE: '/moderation/pool/merge/',
    CREATE_PRODUCT: '/moderation/products/',
    GET_ATTRIBUTE_VALUES: '/moderation/attribute-values/',
    GET_ATTRIBUTE_CONFIGS: '/moderation/attribute-configs/detailed/',
    ADD_VIDEO_TO_PRODUCT: '/moderation/product-videos/',
    ADD_IMAGE_TO_PRODUCT: '/moderation/product-images/',
    VALIDATE_DELETE_PRODUCT: '/moderation/products/:productId/validate-delete/',
    DELETE_PRODUCT: '/moderation/products/:productId/',
    CHANGE_PRODUCT_IMAGES_ORDER: '/moderation/product-images/bulk-update/',
    CHANGE_PRODUCT_VIDEOS_ORDER: '/moderation/product-videos/bulk-update/',
    DELETE_PRODUCT_IMAGE: '/moderation/product-images/:imageId/',
    DELETE_PRODUCT_VIDEO: '/moderation/product-videos/:videoId/',
    UPDATE_PRODUCT: '/moderation/products/:productId/',
    GET_PRODUCT: '/moderation/products/:productId/detailed/',
    ADD_VARIANT: '/moderation/products/:productId/add-variant/',
    GET_BASE_PRODUCTS: '/moderation/base-bottles/',
    GET_BASE_PRODUCT: '/moderation/base-bottles/:baseProductId/',
    CREATE_BASE_PRODUCT: '/moderation/base-bottles/',
    UPDATE_BASE_PRODUCT: '/moderation/base-bottles/:baseProductId/',
    UNMATCH_PRODUCT: '/moderation/products/:productId/unmatch/',
    BLACKLIST_PRODUCT: '/moderation/products/:productId/add-to-blacklist/',
    REMOVE_FROM_BLACKLIST: '/moderation/products/:productId/remove-from-blacklist/',
    CHANGE_BASE_PRODUCT_CATEGORY: '/moderation/base-bottles/:baseProductId/update-category/',
    GET_BASE_PRODUCT_DETAIL: '/moderation/base-bottles/:baseProductId/search/',
    GET_BASE_PRODUCT_ANALYTICS_SUMMARY: '/moderation/base-bottles/:baseProductId/analysis/',
    GET_BASE_PRODUCT_ANALYTICS_RETAILERS: '/moderation/base-bottles/:baseProductId/retailers/',
  },
  ENTITIES: {
    GET_ENTITIES: '/moderation/accounts/detailed/',
    GET_ENTITY: '/moderation/accounts/:entityId/',
    GET_ENTITY_DETAILED: '/moderation/accounts/:entityId/detailed/',
    JUMP_TO_BUSINESS: '/moderation/business/jump/',
    ACTIVATE: '/moderation/accounts/:entityId/activate/',
    DEACTIVATE: '/moderation/accounts/:entityId/deactivate/',
  },
  PRE_ACCOUNTS: {
    GET_PRE_ACCOUNTS: '/moderation/pre-accounts/',
    GET_PRE_ACCOUNT: '/moderation/pre-accounts/:preAccountId',
    CREATE_PRE_ACCOUNT: '/moderation/pre-accounts/',
    UPDATE_PRE_ACCOUNT: '/moderation/pre-accounts/:preAccountId/',
    SEARCH_ACCOUNT: '/moderation/pre-accounts/search/',
    PROMOTE_PRE_ACCOUNT: '/moderation/pre-accounts/:preAccountId/promote/',
  },
  REPORTED_ISSUES: {
    GET_REPORTED_ISSUES: '/moderation/retailer-product-reports/',
    UPDATE_REPORTED_ISSUE: '/moderation/retailer-product-reports/:reportedIssueId/',
  },
  BARCODE_RESOLUTION: {
    GET_BARCODE_PROPOSALS: '/moderation/barcode-resolution/',
    GET_BARCODE_PROPOSAL: '/moderation/barcode-resolution/:proposalId/',
    MATCH_BARCODE_PROPOSAL: '/moderation/barcode-resolution/:proposalId/match/',
    CREATE_BASE_BOTTLE: '/moderation/barcode-resolution/:proposalId/create/',
    REJECT_BARCODE_PROPOSAL: '/moderation/barcode-resolution/:proposalId/reject/',
    MERGE_BARCODE_PROPOSAL: '/moderation/barcode-resolution/:proposalId/merge/',
  },
  BLACKLISTED_PRODUCTS: {
    GET_BLACKLISTED_PRODUCTS: '/moderation/retailer-product-blacklists/actives/',
  },
  POD_FILES: {
    GET_POD_FILES: '/moderation/account-assets/',
  },
  BUSINESS: {
    CREATE_NEW_BUSINESS: '/auth/register/',
  },
  MODERATION_BUSINESS: {
    GET_BUSINESSES: '/moderation/business/detailed/',
    GET_BUSINESS_DETAILED: '/moderation/business/:businessId/detailed/',
    UPDATE_BUSINESS: '/moderation/business/:businessId/',
  },
  MERGE_JOBS: {
    GET_MERGE_JOBS: '/moderation/merge-jobs/',
    REVERT_MERGE: '/moderation/merge-jobs/:mergeJobId/revert/',
    CANCEL_MERGE: '/moderation/merge-jobs/:mergeJobId/cancel/',
    RETRY_MERGE: '/moderation/merge-jobs/:mergeJobId/retry/',
  },
  OVERVIEW: {
    GET_ANALYTICS: '/moderation/analysis/queries/:type/',
    GET_RETAILER_COVERAGE: '/moderation/charts/retailer-map/',
  },
  MISC: {
    GET_REGIONS: '/regions/',
    GET_COUNTRIES: '/countries/',
    GET_MODALITIES: '/modalities/',
    GET_CHAINS: '/moderation/chains/',
  },
  BILLING: {
    // God-Admin tier-change (HITL) endpoints — the #222 BillingOrchestrator.
    // POST-only: initiate returns an approval id, then approve/reject/execute by id.
    // These live outside /moderation/ and require an X-Business-ID header (the
    // `subscription` DRF namespace is business-scoped) — see calls/billing.ts.
    INITIATE_TIER_CHANGE: '/subscriptions/tier-changes/',
    RESOLVE_TIER_CHANGE: '/subscriptions/tier-changes/resolve/',
    APPROVE_TIER_CHANGE: '/subscriptions/tier-changes/:approvalId/approve/',
    REJECT_TIER_CHANGE: '/subscriptions/tier-changes/:approvalId/reject/',
    EXECUTE_TIER_CHANGE: '/subscriptions/tier-changes/:approvalId/execute/',
    // Account setup + provision (#347, epic #346 Slice 1). SIGNUP writes the
    // authoritative platform record (Account + pending Subscription + SignupEvent
    // outbox) — the operator-driven half of the #219 in-platform signup. PROVISION
    // consumes that pending SignupEvent into an `initiated` create-approval (the
    // outbox -> #222 orchestrator seam); the operator then approves + executes it
    // via the tier-change endpoints above (execute drives the Stripe create).
    // Both are X-Business-ID scoped — see calls/billing.ts.
    SIGNUP: '/subscriptions/signup/',
    PROVISION: '/subscriptions/provision/',
    // Read-only listing of pending SignupEvents to provision (#352, epic #346):
    // feeds the provision console picker, replacing the "paste the signup_event id"
    // stop-gap for customer-originated (#219) signups. Business-scoped (X-Business-ID)
    // + God-Admin; returns only pending rows not already provisioned. See calls/billing.ts.
    PROVISION_PENDING: '/subscriptions/provision/pending/',
    // #267 reconciliation board -> #222 HITL (#348, epic #346). RECONCILIATION_ROWS
    // serves the parked #81/#267 rows from platform state (replacing the static FE
    // constants source). RECONCILIATION_EXECUTE repairs ONE row: it maps the row to a
    // #222 `update` approval toward an operator-supplied `to_plan` and drives the
    // existing approve -> execute HITL path server-side (the Stripe write goes through
    // the #214 chokepoint). Per-row only — there is deliberately NO bulk endpoint.
    // Both are God-Admin + X-Business-ID scoped — see calls/billing.ts.
    RECONCILIATION_ROWS: '/subscriptions/reconciliation/rows/',
    RECONCILIATION_EXECUTE: '/subscriptions/reconciliation/:stripeSubscriptionId/execute/',
    // prod -> staging content sync (feat/staging-sync): God-Admin + non-prod-only.
    // POST enqueues the long-running Celery sync (returns a run id); GET returns
    // last-run status. The backend refuses on prod (403) before enqueuing. This
    // is NOT business-scoped (GodAdminPermission only) — no X-Business-ID header.
    STAGING_SYNC: '/subscriptions/staging-sync/',
  },
}

export default endpoints
